import { IResponseState } from "../../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  REPORTS,
  REPO_DEL_STATE,
  REPO_ADD_EDIT_STATE,
  IS_EDIT,
  TO_EDIT,
  ROLES,
  GENERATION_STATE,
  GENERATED,
  VALUE,
  LOADER_IDENTIFIER,
} = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [REPORTS]: [],
  [REPO_DEL_STATE]: IResponseState.PENDING,
  [REPO_ADD_EDIT_STATE]: IResponseState.PENDING,
  [IS_EDIT]: false,
  [TO_EDIT]: {},
  [ROLES]: [],
  [GENERATION_STATE]: IResponseState.PENDING,
  [GENERATED]: [],
  [VALUE]: [],
  [LOADER_IDENTIFIER]: false,
};
